<template>
  <v-app>

    <the-header />

    <the-alerts />

    <v-main>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    </v-main>

    <the-menu />

    <the-loading />

  </v-app>
</template>

<script>
import TheHeader from "@/containers/TheHeader";
import TheMenu from "@/containers/TheMenu";
import TheAlerts from "@/components/TheAlerts";
import TheLoading from "@/components/TheLoading";

export default {
  name: "TheContainer",
  components: {
    TheHeader,
    TheMenu,
    TheAlerts,
    TheLoading,
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
